<p class="text-center">
    <input
        type="checkbox"
        class="checkbox"
        [(ngModel)]="isChecked"
        [disabled]="isChecked"
        (ngModelChange)="changeIsVp()"
    />
</p>
